


import React, { useState, useEffect } from "react";



import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import db from "./Firebase";
import { collection, doc, updateDoc, onSnapshot, orderBy, getDoc, where, getDocs, addDoc, Timestamp, query } from "firebase/firestore";
import Moment from "moment";
import { extendMoment } from "moment-range";

function FinanceQuery() {
    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [remarks, setRemarks] = useState({}); // Local state for remarks

    useEffect(() => {
        const unsubscribe = onSnapshot(
            collection(db, "nv_finance_query"),
            (snapshot) => {
                const sortedData = snapshot.docs
                    .map((doc) => ({ id: doc.id, data: doc.data() }))
                    .sort((a, b) => b.data.created_date - a.data.created_date);
                setData(sortedData);

                // Initialize remarks state with existing remarks from Firestore
                const initialRemarks = {};
                sortedData.forEach(({ id, data }) => {
                    initialRemarks[id] = data.remarks || "";
                });
                setRemarks(initialRemarks);
            }
        );

        return () => unsubscribe();
    }, []);

    // Handle Search Input
    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
    };

    // Handle Status Update
    const handleStatusChange = async (id, msg, newStatus, phone) => {

        const userQuery = query(collection(db, "personal_details"), where("phone_no", "==", phone));
        const querySnapshot = await getDocs(userQuery);

        if (querySnapshot.empty) {
            Swal.fire("Error!", "User not found!", "error");
            return;
        }

        let username = "";
        querySnapshot.forEach((doc) => {
            username = doc.data().username; // Extract username
        });


        try {
            const docRef = doc(db, "nv_finance_query", id);
            await updateDoc(docRef, { status: newStatus });

            Swal.fire("Success", "Status updated!", "success");
            if (newStatus === "Resolved") {
                await addDoc(collection(db, "nv_notifications"), {
                    actions: false,
                    category: "Alert",
                    created_at: new Date(),
                    image: "",
                    is_download: "",
                    is_join: "",
                    redirect_page: "",
                    requested_phone_no: phone,
                    requested_user: username,
                    seen_by: [],
                    status: "1",
                    timestamp: new Date(),
                    title: `Your issue "${msg}" has been resolved. Thank you for your patience!`,
                    type: "private",
                    user_id: username,
                    id: new Date().getTime() + new Date().getMilliseconds(),
                });

                Swal.fire("Resolved!", "The issue has been marked as resolved.", "success");
            }
        } catch (error) {
            console.error("Error updating status:", error);
            Swal.fire("Error", "Failed to update!", "error");
        }
    };

    // Handle Remarks Change (Local)
    const handleRemarksChange = (id, value) => {
        setRemarks((prev) => ({ ...prev, [id]: value }));
    };

    // Save Remarks to Firestore (on Enter or Save Click)
    const saveRemarks = async (id) => {
        try {
            const docRef = doc(db, "nv_finance_query", id);
            await updateDoc(docRef, { remarks: remarks[id] });

            Swal.fire("Success", "Remarks updated!", "success");
        } catch (error) {
            console.error("Error updating remarks:", error);
            Swal.fire("Error", "Failed to update!", "error");
        }
    };

    return (
        <>
            <div className="p-2" style={{ display: "flex", justifyContent: "space-between" }}>
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>

            <div className="p-3">
                <div className="card-header pb-0 px-3">
                    <h6 className="mb-2">Finance Query Page - (Count: {data.length})</h6>
                </div>

                {/* Search Input */}
                <input
                    type="text"
                    className="form-control form-control-sm mb-2"
                    placeholder="Search by phone no..."
                    value={searchQuery}
                    onChange={handleSearch}
                />

                <div className="table-responsive fix-width scroll-inner">
                    <table className="table table-bordered table-hover">
                        <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                            <tr>
                                <th>Sr. No</th>
                                <th>Name</th>
                                <th>Phone No</th>
                                <th>Message</th>
                                <th>Created Date</th>
                                <th>Status</th>
                                <th>Remarks</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data
                                .filter((record) => record.data.phone_no.includes(searchQuery))
                                .map(({ id, data }, index) => (
                                    <tr key={id}>
                                        <td>{index + 1}</td>
                                        <td>{data.full_name}</td> {/* ✅ updated */}
                                        <td>{data.phone_no}</td> {/* ✅ updated */}
                                        <td>{data.message}</td>
                                        <td>{moment(data.created_date.toDate()).format("DD/MM/YY, h:mm a")}</td>
                                        {/* <td>{data.type}</td> */}

                                        {/* Status Dropdown */}
                                        <td>
                                            <select
                                                className="form-control"
                                                value={data.status || "Pending"}
                                                onChange={(e) => handleStatusChange(id, data.message, e.target.value, data.phone_no)}
                                            >
                                                <option value="Pending">Pending</option>
                                                <option value="Resolved">Resolved</option>
                                                <option value="Call not connected">Call not connected</option>
                                            </select>
                                        </td>

                                        {/* Remarks Input (Local State) */}
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter remarks..."
                                                value={remarks[id] || ""}
                                                onChange={(e) => handleRemarksChange(id, e.target.value)}
                                                onKeyDown={(e) => e.key === "Enter" && saveRemarks(id)}
                                            />
                                        </td>

                                        {/* Save Button */}
                                        <td>
                                            <button className="btn btn-sm btn-primary" onClick={() => saveRemarks(id)}>
                                                Save
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default FinanceQuery;
